import { createContext } from 'react'

const AppInsightsTrackingContext = createContext({
  trackEvent: (eventName, data) => {},
})

export default AppInsightsTrackingContext
